module.exports = __webpack_public_path__ + "img/mb1t3.b1511694.png";